<div class="filters-tag" *ngIf="editedFiltersList && editedFiltersList.length">
  <div class="filters-tag-body">
    <div class="filter-tag-wrapper">
      <div class="filter-tag-group" *ngFor="let groupKey of getKeys(tagGroupsList)">
        <div class="filter-tag-group-wrapper"
             *ngIf="tagGroupsList[groupKey] && tagGroupsList[groupKey].length"
             (click)="openTagGroupTooltip(groupKey)">
          <div class="group-length-label">{{tagGroupsList[groupKey].length}}</div>
          <div class="filter-tag-group-title" translate>{{ translateKeyName(groupKey) }}</div>
          <div class="filter-tag-tooltip" [class.expanded]="isTooltipOpened(groupKey)" (clickOutside)="tooltipExit($event)">
            <div class="filters-tag-item filters-tag-editing-link" (click)="editFilterGroup(groupKey)">
              <span>{{'CONTACTS_LIST.SHOW_IN_FILTERS' | translate}}</span>
              <i class="material-icons">keyboard_arrow_right</i>
            </div>
            <div *ngFor="let item of tagGroupsList[groupKey]" class="filters-tag-item"
                 [title]="translateKeyName(groupKey) | translate">
              <span class="filters-tag-title" *ngIf="groupKey !== 'eventTypes'">{{ item.name }}</span>
              <span class="filters-tag-title" *ngIf="groupKey === 'eventTypes'">{{'CONTACTS_LIST.STATUS.'+ item.name | translate}}</span>
              <i class="datatable-icon-close" (click)="removeFilterTag(item)"></i>
            </div>
            <div class="filters-tag-item remove-warned"
                 (click)="removeCollection(groupKey)">{{'CONTACTS_LIST.REMOVE_TAG_COLLECTION' | translate}}</div>
          </div>
          <i class="material-icons filter-tag-group-edit" [title]="'EDIT' | translate"
             >edit</i>
        </div>
      </div>
    </div>
  </div>
</div>

